import React, { Component } from "react";
import Head from "./Head";
import { Hero, TwoCol, Grid } from "ggmm-react-lib";
import axios from "axios";
import bgElement from "../assets/bg-element.svg";
import check from "../assets/check-green.svg";

import JotformEmbed from "react-jotform-embed";

import _ from "lodash";

class Home extends Component {
  constructor() {
    super();
    this.state = {
      homeData: [],
      threeCol: [],
      overlay: true
    };
  }
  componentDidMount() {
    const ROOT_URL = "https://info.ffbwi.com";

    axios
      .get(ROOT_URL + "/wp-json/wp/v2/landingpages?slug=rewards-checking")
      .then(res => {
        let threeCol = [];

        // loop through data
        _.map(res.data[0].acf.main_content_blocks, item => {
          //menu item name
          const content = item.content,
            image = item.image,
            set = {
              image: image,
              content: content
            };
          threeCol.push(set);
        });

        this.setState({
          homeData: res.data[0].acf,
          threeCol: threeCol,
          pageTitle: res.data[0].title.rendered,
          seo: res.data[0].yoast_meta,
          secondaryBlocks: res.data[0].acf.secondary_blocks
        });
      });
  }

  renderSecondaryBlocks() {
    const { secondaryBlocks } = this.state;
    if (secondaryBlocks) {
      return (
        <Grid
          customClass="home-three-col"
          data={secondaryBlocks}
          type="icon"
          columns="3"
          align="center"
          mobileColumns="1"
          // imageCover={true}
          gridGap="50px"
          imageHeight="200px"
        />
      );
    }
  }
  renderMarkup = content => {
    return { __html: content };
  };

  isOdd = number => {
    return number % 2;
  };

  renderColumns() {
    const { threeCol } = this.state;
    return _.map(threeCol, (o, i) => {
      if (this.isOdd(i)) {
        return (
          <TwoCol
            maxWidth="1200px"
            customClass="home-two-col-body"
            right="image"
            alignItems="center"
            left="text"
            imageHeight="380px"
            leftWidth="50%"
            rightContent={o.image}
            rightWidth="50%"
            leftContent={o.content}
          />
        );
      } else {
        return (
          <TwoCol
            maxWidth="1200px"
            customClass="home-two-col-body"
            left="image"
            alignItems="center"
            imageHeight="380px"
            right="text"
            leftWidth="50%"
            leftContent={o.image}
            rightWidth="50%"
            rightContent={o.content}
          />
        );
      }
    });
  }

  renderHead() {
    const { threeCol, seo, pageTitle } = this.state,
      url = window.location.href;

    if (seo && threeCol[0]) {
      return (
        <Head
          pageTitle={pageTitle}
          url={url}
          ogImage={threeCol[0].image}
          des={seo.yoast_wpseo_metadesc}
        />
      );
    }
  }

  render() {
    const { homeData } = this.state;
    return (
      <div>
        {this.renderHead()}
        <Hero
          customClass="home-hero"
          childClass="two-col-container"
          type="image"
          overlay={homeData.overlay ? true : false}
          imageUrl={homeData.background_image}
          hasChildren={true}
        >
          {this.props.location.search === "?form_submitted" && (
            <TwoCol
              alignItems="center"
              minHeight="768"
              customClass="home-two-col"
              left="text"
              right="children"
              leftWidth="50%"
              leftContent={homeData.headline}
              rightWidth="50%"
            >
              <div className="form-header">
                <img
                  style={{ margin: "40px", width: "80px" }}
                  src={check}
                  alt="Success"
                />
                <h2 className="thank-you">
                  Thank You. We'll be in touch with you shortly.
                </h2>
              </div>
            </TwoCol>
          )}
          {this.props.location.search !== "?form_submitted" && (
            <TwoCol
              alignItems="center"
              height="100%"
              customClass="home-two-col"
              left="text"
              right="children"
              leftWidth="50%"
              rightWidth="50%"
            >
              <div className="form-header">
                <h1
                  dangerouslySetInnerHTML={this.renderMarkup(homeData.headline)}
                />
                <p
                  dangerouslySetInnerHTML={this.renderMarkup(
                    homeData.form_content
                  )}
                />
                <JotformEmbed src={homeData.jotform_code} />
              </div>
            </TwoCol>
          )}
        </Hero>
        <div className="main-container">
          <img
            src={bgElement}
            alt="Background Element"
            className="bg-element"
          />

          <h2 className="secondary-header">{homeData.secondary_headline}</h2>

          {this.renderColumns()}
          <img
            src={bgElement}
            alt="Background Element"
            className="bg-element reverse"
          />
        </div>

        {this.renderSecondaryBlocks()}

        <div id="contact-footer" className="contact-hero">
          <Hero
            type="image"
            overlay={false}
            imageUrl={homeData.footer_image}
            height="100"
            minHeight="768"
            hasChildren={true}
            centerChildren={true}
          >
            <div className="form-header">
              <div
                dangerouslySetInnerHTML={this.renderMarkup(
                  homeData.form_content
                )}
              />
              <JotformEmbed src={homeData.jotform_code} />
            </div>
          </Hero>
        </div>
      </div>
    );
  }
}

export default Home;



// WEBPACK FOOTER //
// ./src/components/Home.js